import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {SharedModule} from '../shared/shared.module'
import {EventsSectionComponent} from './events-section.component'


@NgModule({
  declarations: [EventsSectionComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [EventsSectionComponent]
})
export class EventsSectionModule {
}
